class YCLatLng {
  constructor(lat, lng) {
    this.x = lng;
    this.y = lat;
  }

  lat() {
    return this.y;
  }

  lng() {
    return this.x;
  }
}

export default YCLatLng;
